// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop, omit } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"
import { devLog } from "@helpers/devLog"

/** initla state for auth store  */
const initialState = {
  data: [],
  sales: [],
  items: [],
  count: "",
  current: {},
  perPageValues: [25, 50, 100, 150, 200],
  itemPerPage: 25,
  itemPerPageItems: 25,
  currentPage: 1,
  currentPageItems: 1,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  filtersItems: {
    parent: {
      value: "ALL",
      label: "label_all"
    },
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  keyWordItems: null,
  action: globalConst.action.NONE
}

export const showRoomsItems = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPageItems: (s, payload) => {
      return {
        ...s,
        currentPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCount: (s, payload) => {
      return {
        ...s,
        count: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateItem: (s, payload) => {
      const index = s.items.findIndex((e) => e.pk === payload.pk)
      const item = s.items[index]
      item.images = item.images.filter((e) => e !== payload.image)
      const _data = s.items.filter((e) => e.pk !== payload.pk)
      _data[index] = item

      return {
        ...s,
        items: _data
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateSingleItem: (s, payload) => {
      const index = s.items.findIndex((e) => e.pk === payload.pk)
      const item = payload
      const _data = s.items.filter((e) => e.pk !== payload.pk)
      _data[index] = item

      return {
        ...s,
        items: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setItems: (s, payload) => {
      return {
        ...s,
        items: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSales: (s, payload) => {
      return {
        ...s,
        sales: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeywordItems: (s, payload) => {
      return {
        ...s,
        keyWordItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSubItemsPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.showRoomsItems],
        (showRoomsItems, showRoomsItemsLoading) => {
          return showRoomsItemsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.showRoomsItems],
        (showRoomsItems, showRoomsItemsLoading) => showRoomsItemsLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (showRoomsItems) => {
        let _data = showRoomsItems.data
        if (!isEmpty(showRoomsItems.filters)) {
          const status = showRoomsItems.filters.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
        }
        if (!!showRoomsItems.keyword) {
          const options = {
            keys: ["phone", "title", "titleAr", "whatsapp"]
          }
          const fuse = new Fuse(showRoomsItems.data, options)
          _data = fuse.search(showRoomsItems.keyword)
          _data = _data.map((e) => e.item)
        }
        const offset = (showRoomsItems.currentPage - 1) * showRoomsItems.itemPerPage
        _data = drop(_data, offset).slice(0, showRoomsItems.itemPerPage)
        return _data
      })
    },

  }),
  effects: (dispatch) => ({


    async fetchItems(type = "all") {
      appLogger.info("fetchItems", `[REDUX][${STORES.SHOWROOMS_ITEMS}]`)
      this.setAction(globalConst.action.FETCH_SHOWROOMS_ITEMS)
      try {
        const result = await API.get(
          "adminsApi",
          `/show-rooms-items/v1?ack=${type}`
        )

        this.setData(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     */
    async getShowRoomItem(pk) {
      appLogger.info("GET_SHOWROOM_ITEM", `[REDUX][${STORES.SHOWROOMS_ITEMS}]`)
      this.setAction(globalConst.action.GET_SHOWROOM_ITEM)
      try {
        const result = await API.get(
          "adminsApi",
          `/show-rooms-items/v1/items/${pk}`
        )

        this.setCurrent(result)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    async updateShowRoomItem({pk,payload,sk}) {
        appLogger.info("GET_SHOWROOM_ITEM", `[REDUX][${STORES.SHOWROOMS_ITEMS}]`)
        this.setAction(globalConst.action.UPDATE_SHOWROOM_ITEM)
        try {
         await API.put(
            "adminsApi",
            `/show-rooms-items/v1/items/${pk}/status`,{
                body:{...payload,sk}
            }
          )
       
          this.setMessage("ShowRoom item updated successfully")
  
          // this.setCount(count)
        } catch (error) {
          devLog(error)
          throw new Error(error)
        }
      },
    /**
     * 
     * @param {*} payload 
     */
    async saveShowRoom(payload) {
      appLogger.info("saveShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.SAVE_SHOWROOM)
      try {

         await API.post(
          "adminsApi",
          `/show-rooms/v1`,
          {
            body:payload
          }
        )

        this.setMessage("msg_showroom_saved_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async updateShowRoom(payload) {
      appLogger.info("updateShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.UPDATE_SHOWROOM)
      try {

         await API.put(
          "adminsApi",
          `/show-rooms/v1/${payload.pk}`,
          {
            body:omit(payload, ["pk"])
          }
        )

        this.setMessage("msg_showroom_update_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async activateShowRoom(payload) {
      appLogger.info("activateShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.ACTIVATE_SHOWROOM)
      try {
    

         await API.put(
          "adminsApi",
          `/show-rooms/v1/${payload.pk}/activate`,
          {
            body: omit(payload, ["pk"])
          }
        )

        this.setMessage("msg_showroom_activate_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async resetShowRoom(payload) {
      appLogger.info("resetShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.RESET_SHOWROOM)
      try {

         await API.post(
          "adminsApi",
          `/show-rooms/v1/${payload.pk}/reset`,
          {
            body:omit(payload, ["pk"])
          }
        )

        this.setMessage("msg_showroom_reset_password_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async enableShowRoom(payload) {
      appLogger.info("enableShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.ENABLE_SHOWROOM)
      try {

         await API.put(
          "adminsApi",
          `/show-rooms/v1/${payload.pk}/enable`,
          {
          }
        )

        this.setMessage("msg_showroom_enable_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },
    /**
     * 
     * @param {*} payload 
     */
    async disableShowRoom(payload) {
      appLogger.info("disableShowRoom", `[REDUX][${STORES.SHOWROOMS}]`)
      this.setAction(globalConst.action.DISABLED_SHOWROOM)
      try {

         await API.del(
          "adminsApi",
          `/show-rooms/v1/${payload.pk}/disable`
        )

        this.setMessage("msg_showroom_disable_succes")

      } catch (error) {
        devLog(error)
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} pk
     */
    async deleteAgenceItem({ pk, createdAt }) {
      appLogger.info(`deleteAgenceItem ${pk}`, `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.DELETE_AGENCES_ITEM)
      try {
        await API.post("exhibitionsApiGateway", `/exibitions/${pk}/rm`, {
          body: { createdAt }
        })
        this.setMessage("msg_agency_deleted_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },


    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onSubItemPerPageChange(payload) {
      this.setSubItemsPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemsCurrentPageChange(payload) {
      this.setCurrentPageItems(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemKeywordChanges(payload) {
      this.setKeywordItems(payload)
    }
  })
}
